<template>
    <div class="navi">
        <router-link v-if="isActive([role.role_admin, role.role_headOffice_division])"
            :to='getLinkTarget("KenshinDivisionRequestAccept", "/philips/kenshin/KenshinDivisionRequestAccept")'>
            <div :class='getClass("KenshinDivisionRequestAccept")'><b-icon icon="stamper"/>検診Ｇ受付</div>
        </router-link>
        <router-link v-if="isActive([role.role_admin, role.role_kawagoe])"
             :to='getLinkTarget("KenshinRequestAccept", "/philips/kenshin/KenshinRequestAccept")'>
            <div :class='getClass("KenshinRequestAccept")'><b-icon icon="stamper"/>川越受付</div>
        </router-link>
        <router-link v-if="isActive([role.role_admin, role.role_kawagoe])"
             :to='getLinkTarget("KenshinDevicePreparation", "/philips/kenshin/KenshinDevicePreparation")'>
            <div :class='getClass("KenshinDevicePreparation")'><b-icon icon="barcode-scan"/>機器準備</div>
        </router-link>
        <router-link v-if="isActive([role.role_admin, role.role_kawagoe])"
             :to='getLinkTarget("KenshinShippingList", "/philips/kenshin/KenshinShippingList")'>
            <div :class='getClass("KenshinShippingList")'><b-icon icon="truck-delivery-outline"/>機器出荷</div>
        </router-link>
        <router-link v-if="isActive([role.role_admin, role.role_kawagoe])"
             :to='getLinkTarget("KenshinDeviceReturn", "/philips/kenshin/KenshinDeviceReturn")'>
            <div :class='getClass("KenshinDeviceReturn")'><b-icon icon="receipt"/>機器受領</div>
        </router-link>
        <router-link v-if="isActive([role.role_admin, role.role_kawagoe])"
             :to='getLinkTarget("KenshinExtractData", "/philips/kenshin/KenshinExtractData")'>
            <div :class='getClass("KenshinExtractData")'><b-icon icon="flask-plus-outline"/>データ抽出</div>
        </router-link>
        <router-link v-if="isActive([role.role_admin, role.role_kawagoe])"
             :to='getLinkTarget("KenshinJudgmentOrder", "/philips/kenshin/KenshinJudgmentOrder")'>
            <div :class='getClass("KenshinJudgmentOrder")'><b-icon icon="offer"/>判定依頼</div>
        </router-link>
        <router-link v-if="isActive([role.role_admin, role.role_kawagoe])"
             :to='getLinkTarget("KenshinReportCreate", "/philips/kenshin/KenshinReportCreate")'>
            <div :class='getClass("KenshinReportCreate")'><b-icon icon="file-document-edit-outline"/>判定結果作成</div>
        </router-link>
        <router-link v-if="isActive([role.role_admin, role.role_kawagoe, role.role_headOffice_division])"
             :to='getLinkTarget("KenshinRequestSearch", "/philips/kenshin/KenshinRequestSearch")'>
            <div :class='getClass("KenshinRequestSearch")'><b-icon icon="text-search"/>案件確認</div>
        </router-link>
        <router-link v-if="isActive([role.role_admin, role.role_kawagoe])"
             :to='getLinkTarget("KenshinRequestContentChange", "/philips/kenshin/KenshinRequestContentChange")'>
            <div :class='getClass("KenshinRequestContentChange")'><b-icon icon="text-box-check"/>受付内容変更</div>
        </router-link>
    </div>
</template>

<script>
import {role} from "@/components/mock/base/const.js";
export default {
  name: "KenshinNaviBar",
  props: ["pageid"],
  methods: {
      getLinkTarget: function(tabkind, target){
          var ret = target;
          if(tabkind == this.pageid){
              ret = ""
          }
          return ret;
      },
      getClass: function(tabkind) {
          var ret = "tabLabel ";
          if(tabkind == this.pageid){
            ret += "active";
          } else {
            ret += "deactive";
          }
          return ret;
      },
      isActive: function(roles){
          return (roles.indexOf(this.roleId) >= 0);
      }    
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    return {
      role: role,
      roleId: roleId
    };
  },
  filters: {},
  components: {},

};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
.navi {
    height: 20px;
    width:2000px;
    margin-top:-20px;
}
.tabLabel {
    float:left;
    text-align: center; 
    border-radius: 10px 10px 0px 0px;
    border-width:1px;
	border-top-style: solid;
	border-right-style: solid;
	border-left-style: solid;
    width: 130px;
    height: 30px;
}
.tabLabel.active {
    color: white;
	border-color: #000894;
    background-color: #000894;
}
.tabLabel.deactive {
	border-color: #f7f7f7;
    background-color: #e4e4e4;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/kenshin/KenshinNaviBar.vue